import { round } from 'lodash';
import FormatMixin from '../../../../Application/mixins/FormatMixin';
import clientStore from '../../../../Person/modules/Client/store';
import ibsRegimeStore from '../../../../Fiscal/modules/IBSRegime/store';
import unitOfMeasureStore from '../../UnitOfMeasure/store';
import { numberBRToFloat } from '../../../../../core/helpers/formater/number';

const { valorReal } = FormatMixin.methods;

export const productTabInformationToEdit = (
  productOfPurchaseOnFiscalEdit,
  decimalConfiguration,
) => {
  const { productData } = productOfPurchaseOnFiscalEdit;
  const { quantity } = decimalConfiguration;

  return {
    productData: {
      ...productData,
      quantityPurchased: valorReal(round(productData.quantityPurchased, quantity), quantity),
      discount: productData.vDesc,
    },
  };
};

export const fiscalValuesToEdit = (productOfPurchaseOnFiscalEdit) => {
  const { values } = productOfPurchaseOnFiscalEdit.fiscal;

  return {
    values: {
      ...values,
      pIPI: valorReal(values.pIPI, 4),
      pPIS: valorReal(values.pPIS, 4),
      pCOFINS: valorReal(values.pCOFINS, 4),
      pICMS: valorReal(values.pICMS, 4),
      pICMSST: valorReal(values.pICMSST, 4),
      pST: valorReal(values.pST, 4),
      pMVAST: valorReal(values.pMVAST, 4),
      pFCPST: valorReal(values.pFCPST, 4),
      cst: values.cst ?? null,
      cfop: values.cfop ?? null,
      csosn: values.csosn ?? null,
      cstIpi: values.cstIpi ?? null,
      cenq: values.cenq ?? null,
      cstPis: values.cstPis ?? null,
      cstCofins: values.cstCofins ?? null,
      origem: values.origem ?? null,
    },
  };
};

const getUTrib = async (productInventoryFiscal) => {
  let uTrib =
    productInventoryFiscal.unitOfMeasure?.acronym?.substring(0, 6) ?? null;

  if (
    productInventoryFiscal.unitOfMeasure?.unidadeMedidaTributavel &&
    productInventoryFiscal.unitOfMeasure?.id
  ) {
    const unitOfMeasure = await unitOfMeasureStore.actions.getUnitOfMeasureById({}, {
      id: productInventoryFiscal.unitOfMeasure?.id,
    });

    if (unitOfMeasure) {
      uTrib =
        unitOfMeasure?.[0]?.unidadeMedidaTributavel?.sigla?.substring(
          0,
          6,
        ) || uTrib;
    }
  }

  return uTrib;
};

const stdIbsTaxRegime = async (productInventoryFiscal) => {
  const { produto } = productInventoryFiscal.fiscal;

  const cMun = clientStore.state.client.addressCollection?.[0]?.zipCode?.city?.code ?? '';
  const cUF = clientStore.state.client.addressCollection?.[0]?.zipCode?.city?.state?.code ?? '';

  const aliquots = await ibsRegimeStore.actions.getIbsTaxRegimeAliquots({}, {
    cMun,
    cUF,
    cClassTrib: produto.ibsRegime?.classTribIBSCBS?.codigo ?? '',
    cClassTribReg: produto.ibsRegime?.classTribIBSCBSReg?.codigo ?? '',
  });

  const indGCredPres =
    produto.ibsRegime?.classTribIBSCBS?.ind_gCredPres;
  const indGTribRegular =
    produto.ibsRegime?.classTribIBSCBS?.ind_gTribRegular;
  const indGDif = produto.ibsRegime?.CSTIBSCBS?.ind_gDif;

  const uTrib = await getUTrib(productInventoryFiscal);

  return {
    CST: produto.ibsRegime?.CSTIBSCBS?.codigo || null,
    cClassTrib:
      produto.ibsRegime?.classTribIBSCBS?.codigo || null,
    vBC: 0,
    vIBS: 0,
    IBSUF: {
      pIBSUF: aliquots?.IBSUF?.pIBSUF || 0,
      vIBSUF: 0,
      pDif: indGDif
        ? produto.ibsRegime?.diferimentoIBSUF || 0
        : 0,
      vDif: 0,
      vDevTrib: 0,
      pRedAliq: produto.ibsRegime?.reducaoIBSUF || 0,
      pAliqEfet: aliquots?.IBSUF?.pAliqEfet || 0,
    },
    IBSMun: {
      pIBSMun: aliquots?.IBSMun?.pIBSMun || 0,
      vIBSMun: 0,
      pDif: indGDif
        ? produto.ibsRegime?.diferimentoIBSMun || 0
        : 0,
      vDif: 0,
      vDevTrib: 0,
      pRedAliq: produto.ibsRegime?.reducaoIBSMun || 0,
      pAliqEfet: aliquots?.IBSMun?.pAliqEfet || 0,
    },
    CBS: {
      pCBS: aliquots?.CBS?.pCBS || 0,
      vCBS: 0,
      pDif: indGDif ? produto.ibsRegime?.diferimentoCBS || 0 : 0,
      vDif: 0,
      vDevTrib: 0,
      pRedAliq: produto.ibsRegime?.reducaoCBS || 0,
      pAliqEfet: aliquots?.CBS?.pAliqEfet || 0,
    },
    gTribRegular: {
      CSTReg: indGTribRegular
        ? produto.ibsRegime?.CSTIBSCBSReg?.codigo || null
        : null,
      cClassTribReg: indGTribRegular
        ? produto.ibsRegime?.classTribIBSCBSReg?.codigo || null
        : null,
      pAliqEfetRegIBSUF: aliquots?.tribReg?.pAliqEfetRegIBSUF || 0,
      vTribRegIBSUF: 0,
      pAliqEfetRegIBSMun: aliquots?.tribReg?.pAliqEfetRegIBSMun || 0,
      vTribRegIBSMun: 0,
      pAliqEfetRegCBS: aliquots?.tribReg?.pAliqEfetRegCBS || 0,
      vTribRegCBS: 0,
    },
    gCredPresOper: {
      vBCCredPres: 0,
      cCredPres:
        produto.ibsRegime?.codCredPresuNFe?.codigo || null,
      gIBSCredPres: {
        pCredPres: indGCredPres
          ? produto.ibsRegime?.aliqCredPresuNFeIBS || 0
          : 0,
        vCredPres: 0,
        vCredPresCondSus: 0,
      },
      gCBSCredPres: {
        pCredPres: indGCredPres
          ? produto.ibsRegime?.aliqCredPresuNFeCBS || 0
          : 0,
        vCredPres: 0,
        vCredPresCondSus: 0,
      },
    },
    IS: {
      CSTIS: produto.ibsRegime?.CSTIS?.codigo || null,
      cClassTribIS:
        produto.ibsRegime?.classTribIS?.codigo || null,
      vBCIS: 0,
      pIS: produto.ibsRegime?.pIS || 0,
      pISEspec: produto.ibsRegime?.aliqEspec || 0,
      uTrib,
      qTrib: numberBRToFloat(productInventoryFiscal.quantityPurchased),
      vIS: 0,
    },
  };
};

export const inventoryProductFiscalInformation = async (productInventoryFiscal) => {
  const { produto } = productInventoryFiscal.fiscal;

  return {
    values: {
      cfop: produto.CFOP,
      origem: produto.origem,
      cst: produto.CST,
      csosn: produto.CSOSN,
      cstIpi: produto.CSTIPI,
      cenq: produto.CENQ,
      cstPis: produto.CSTPIS,
      cstCofins: produto.CSTCOFINS,
    },
    ids: {
      cfopId: produto.CFOP?.id,
      ncmId: produto.NCM?.id,
      cenqId: produto.CENQ?.id,
      cestId: produto.CEST?.id,
      origemId: produto.origem?.id,
      cstId: produto.CST?.id,
      anpId: produto.ANP?.id,
      csosnId: produto.CSOSN?.id,
      cstIPIId: produto.CSTIPI?.id,
      cstPISId: produto.CSTPIS?.id,
      cstCOFINSId: produto.CSTCOFINS?.id,
    },
    IBSTaxRegime: await stdIbsTaxRegime(productInventoryFiscal),
  };
};
